"use client";

import { useTranslations } from "@jti/ui/providers/useTranslations";

import { AttributeFilterSections, useProductAttributeFiltersDrawer } from "@commerce/features";
import { FiltersDrawer } from "@commerce/ui";

import type { FilterableProduct } from "./config";
import type { FilterSectionConfig, RawAttributeAggregations, SelectedAttributes } from "./types";

export type ProductAttributeFiltersDrawerProps = {
  attributeAggregations: RawAttributeAggregations;
  products: FilterableProduct[];
  selectedAttributes: SelectedAttributes;
  onApply: (attributes: SelectedAttributes) => void;
  onReset: () => void;
  filterSections?: FilterSectionConfig[];
};

export const ProductAttributeFiltersDrawer = ({
  filterSections,
  attributeAggregations,
  products,
  selectedAttributes,
  onApply,
  onReset,
}: ProductAttributeFiltersDrawerProps) => {
  const { __ } = useTranslations();
  const {
    sections,
    expandedSectionId,
    resultsCount,
    activeFiltersCount,
    toggleOption,
    applyDraft,
    resetDraft,
    syncDraftFromApplied,
  } = useProductAttributeFiltersDrawer({
    attributeAggregations,
    products,
    filterSections,
    selectedAttributes,
    onApply,
    onReset,
  });

  if (sections.length === 0) return null;

  return (
    <FiltersDrawer
      activeFiltersCount={activeFiltersCount}
      resultsLabel={__("plp.filters.results_count", [resultsCount])}
      labels={{
        backButtonLabel: __("plp.filters.back_button"),
        title: __("plp.filters.title"),
        filterByLabel: __("plp.filters.filter_by"),
        resetLabel: __("plp.filters.reset"),
        showResultsLabel: __("plp.filters.show_results"),
      }}
      onApply={applyDraft}
      onReset={resetDraft}
      onDrawerOpen={syncDraftFromApplied}
    >
      <AttributeFilterSections
        sections={sections}
        expandedSectionId={expandedSectionId}
        onToggleOption={toggleOption}
      />
    </FiltersDrawer>
  );
};
